import React from 'react';
import { injectIntl } from 'react-intl';
import ErrorContainer from './ErrorContainer';
import FeedBack from './FeedBack';
import formPropTypes from '../../prop-types/formPropTypes';
import { TransitionItem } from '~helpers';

var FormInputFeedback = function FormInputFeedback(_ref) {
  var intl = _ref.intl,
      skin = _ref.skin,
      id = _ref.id,
      feedbackType = _ref.feedbackType,
      message = _ref.message,
      centered = _ref.centered,
      children = _ref.children;

  var _ref2 = message ? message.split('__') : '',
      messageTag = _ref2[0],
      value1 = _ref2[1],
      value2 = _ref2[2];

  return /*#__PURE__*/React.createElement(TransitionItem, {
    appear: true,
    inProp: !!(message || children)
  }, /*#__PURE__*/React.createElement(ErrorContainer, {
    centered: centered,
    "aria-live": "polite"
  }, /*#__PURE__*/React.createElement(FeedBack, {
    feedbackType: feedbackType,
    id: id + "-" + feedbackType,
    skin: skin
  }, message && intl.formatMessage({
    id: messageTag
  }, {
    value1: value1,
    value2: value2
  }), children)));
};

FormInputFeedback.defaultProps = {
  skin: 'dark',
  message: undefined,
  children: undefined,
  centered: false
};
export default injectIntl(FormInputFeedback);